import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import NextLink from 'next/link';
import { forwardRef } from 'react';

const LinkFactory = (routesPermissions) => {
    const getPathForRoute = (route) => {
        return routesPermissions[route].path;
    };
    const NinjaNextLink = forwardRef((_a, ref) => {
        var { route, query, children } = _a, rest = __rest(_a, ["route", "query", "children"]);
        const urlQuery = query ? `?${new URLSearchParams(query).toString()}` : '';
        const url = getPathForRoute(route) + urlQuery;
        return (jsx(NextLink, Object.assign({ href: url, ref: ref }, rest, { children: children })));
    });
    NinjaNextLink.displayName = 'NinjaNextLink';
    return NinjaNextLink;
};

export { LinkFactory };
